import { render, staticRenderFns } from "./writeMe.vue?vue&type=template&id=2a9a34b8&scoped=true"
import script from "./writeMe.vue?vue&type=script&lang=js"
export * from "./writeMe.vue?vue&type=script&lang=js"
import style0 from "./writeMe.vue?vue&type=style&index=0&id=2a9a34b8&prod&lang=scss&scoped=true"
import style1 from "./writeMe.vue?vue&type=style&index=1&id=2a9a34b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9a34b8",
  null
  
)

export default component.exports